import { WitnessPromptComponent } from './witness-prompt/witness-prompt.component';
import { BusResComponent } from './bus-res/bus-res.component';
import { HowMuchComponent } from './how-much/how-much.component';
import { ActionComponent } from './action/action.component';
import { Routes } from '@angular/router';
import { LandingComponent } from './landing/landing.component';
import { ThankyouComponent } from './thankyou/thankyou.component';
import { HowOftenComponent } from './how-often/how-often.component';
import { ZipComponent } from './zip/zip.component';

export const routes: Routes = [
  {
    path: '',
    component: LandingComponent,
    data: { animation: 'LandingPage' }
  },
  {
    path: 'config',
    canActivate: [],
    children: [
      { path: 'bus-res', component: BusResComponent },
      { path: 'how-much', component: HowMuchComponent, data: { animation: 'HowMuchPage' } },
      { path: 'witness-prompt', component: WitnessPromptComponent, data: { animation: 'WitnessPromptPage' } },
      { path: '', redirectTo: 'how-much', pathMatch: 'full' },
      { path: 'how-often', component: HowOftenComponent, data: { animation: 'WitnessPromptPage' } },
      { path: 'zip', component: ZipComponent, data: {animation: 'WitnessPromptPage'} }
    ]
  },
  {
    path: 'action/:type',
    component: ActionComponent,
    canActivate: [],
    data: { animation: 'ActionPage' }
  },
  { path: 'thank', component: ThankyouComponent, canActivate: [], data: { animation: 'ThankPage' } },
  { path: '**', redirectTo: '', pathMatch: 'full' }
];
